// Import model
import { ContactAppointmentCondition } from '../models/ContactAppointmentCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ContactAppointmentIndexedFields } from '../models/ContactAppointmentIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ContactAppointmentIndexedFieldsSerializer } from './ContactAppointmentIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ContactAppointmentCondition - handles JSON serialization and deserialization with type validation
 */
export class ContactAppointmentConditionSerializer {
  /**
   * Deserializes a JSON string into a ContactAppointmentCondition instance
   */
  static deserialize(json: string): ContactAppointmentCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ContactAppointmentCondition instance
   */
  static fromObject(obj: any): ContactAppointmentCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ContactAppointmentCondition');
    }


    const instance: ContactAppointmentCondition = {
      fieldName: obj['fieldName'] as ContactAppointmentIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ContactAppointmentCondition instances
   */
  static deserializeArray(json: string): ContactAppointmentCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ContactAppointmentCondition instance to a JSON string
   */
  static serialize(instance: ContactAppointmentCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ContactAppointmentCondition instance to a plain object
   */
  static toObject(instance: ContactAppointmentCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ContactAppointmentCondition instances to a JSON string
   */
  static serializeArray(instances: ContactAppointmentCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
